import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver from 'src/StateObserver';
import uiConfig from 'src/lib/ui/config';
import i18n from 'src/lib/i18n/i18n';

type GrowthCapsulePanelOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
>;

export class GrowthCapsulePanel extends ImageScaleView {
  constructor({ ...opts }: GrowthCapsulePanelOpts = {}) {
    super({
      ...opts,
      ...uiConfig.buruburu.care.confirmation.careItemPanel,
    });

    // icon
    this.addSubview(
      new ImageScaleView({
        scaleMethod: 'contain',
        x: 20,
        y: 20,
        width: 156,
        height: 137,
        image: 'assets/ui/growthacceleration/growthcapsule.png',
      }),
    );

    this.addSubview(
      new LangBitmapFontTextView({
        font: 'Body',
        color: '#9A7171',
        y: 25,
        size: 30,
        x: 190,
        height: 39,
        width: 283,
        localeText: () => i18n('growthcapsule.name'),
        verticalAlign: 'bottom',
      }),
    );

    // description
    this.addSubview(
      new LangBitmapFontTextView({
        size: 25,
        x: 190,
        y: 85,
        width: 283,
        height: 64,
        font: 'Body',
        color: '#9A7171',
        localeText: () => i18n('growthcapsule.description'),
        wordWrap: StateObserver.getState().ui.locale === 'en',
      }),
    );
  }
}
